import React from 'react';
import { Button, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { RateFee } from './rateFees';
import Style from './ratefeeseditor.module.css';

const EMPTY_FEE = { name: null, amount: 0, amount_no_tax: 0 };

export default function RateFeesEditor({ fees, setForm, event, onChange, titleKey, formFieldKey = 'fees' }) {
    const { t } = useTranslation();

    const addFees = React.useCallback(() => {
        if (!fees.length) {
            return setForm(formFieldKey, [EMPTY_FEE]);
        }
        return setForm(formFieldKey, [...fees, EMPTY_FEE]);
    }, [fees]);

    const handleChange = React.useCallback(
        (fee_array_indice, fee_attribute = null) => {
            let tmp_fees = [...fees];
            // if fees_attribute is null, delete fee from array, else replace the value
            if (fee_attribute) {
                tmp_fees[fee_array_indice] = { ...tmp_fees[fee_array_indice], ...fee_attribute };
            } else {
                tmp_fees.splice(fee_array_indice, 1);
            }
            onChange(tmp_fees);
        },
        [onChange, fees]
    );

    return (
        <>
            <div className={Style['fees-cta-container']}>
                <div className={`${Style['fees-cta-title']} ${fees.length > 0 ? Style['has-fees'] : ''}`}>{t(titleKey, { count: fees.length })}</div>
                <div className={Style['container']}>
                    <div className={Style['fees']}>
                        {fees.map((fee, i) => (
                            <RateFee
                                key={i}
                                displayExclVatLabel
                                fee={fee}
                                currency={event?.currency}
                                onChange={value => handleChange(i, value)}
                                displayExclVat={false}
                                includeTaxInPrice={() => 0}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <Button primary inverted onClick={addFees} icon={<Icon name="plus" />} label={t('ticket.rates.infos.fees.more')} />
        </>
    );
}
